module.exports = __webpack_public_path__ + "static/media/WhiteArrow.f8039053.svg";